import { render, staticRenderFns } from "./corporateTable.vue?vue&type=template&id=b918197e&"
import script from "./corporateTable.vue?vue&type=script&lang=js&"
export * from "./corporateTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports